<template>
  <div class="gym_star">
    <div
      v-for="(item, index) in showNum"
      :key="index"
      v-show="index <= starNum - 1 && !showGrey"
      class="star-item iconfont icon-shoucang1"
      :class="{ 'star-not-active': index > starNum - 1 }"
      :style="{ fontSize: 5.33 * scale + 'vw' }"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    scale: {
      type: Number,
      default: 1
    },
    starNum: {
      type: Number,
      default: 0
    },
    showNum: {
      type: Number,
      default: 5
    },
    //是否显示灰色的星星
    showGrey: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.icon-shoucang1 {
  color: #f7b500;
}
.star-not-active {
}
.star-item {
  margin: 0vw 0.4vw;
}
.gym_star {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
